import React, { useState, useEffect } from 'react';
import '../dashboard/Dashboard.css';

type Campaign = {
  id: number;
  status: string;
  adFormat: string;
  campaignName: string;
  bid: number;
  geo: string;
  bidRequests: number;
  videoImpressions: number;
  visits: number;
  winRate: number;
  cost: number;
  dailyCap: number;
};

const OpenSupportTicketPage: React.FC = () => {
  const [campaigns, setCampaigns] = useState<Campaign[]>([]);
  const [noData, setNoData] = useState<boolean>(false);

  // Example of summing fields
  const calculateTotals = () => {
    return campaigns.reduce(
      (totals, campaign) => {
        totals.totalCost += campaign.cost;
        totals.totalImpressions += campaign.videoImpressions;
        totals.totalVisits += campaign.visits;
        totals.totalBidRequests += campaign.bidRequests;
        totals.totalWinRate += campaign.winRate;
        totals.totalDailyCap += campaign.dailyCap;
        return totals;
      },
      {
        totalCost: 0,
        totalImpressions: 0,
        totalVisits: 0,
        totalBidRequests: 0,
        totalWinRate: 0,
        totalDailyCap: 0,
      }
    );
  };

  const fetchData = async () => {
    try {
      const baseUrl =
        window.location.hostname === 'localhost'
          ? `http://localhost:5000/api/allData`
          : `https://bidvertiser-api.vercel.app/api/campaigns/allData`;

      const response = await fetch(baseUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      if (data.campaigns.length === 0) {
        setNoData(true);
      } else {
        setNoData(false);
        setCampaigns(data.campaigns);
      }
    } catch (error) {
      console.error('Error fetching campaigns:', error);
      setNoData(true);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const totals = calculateTotals();

  return (
   <></>
  );
};

export default OpenSupportTicketPage;
